export const JOB_ADS_QUERY_KEY = "jobAds"

export const JOB_ADS_STATE_QUERY_KEY = "jobAds::savedState"
export const SEEN_JOB_ADS_QUERY_KEY = "jobAds::seen"
export const SCREENING_QUESTIONS_QUERY_KEY = "jobAds::screeningQuestions"
export const JOB_ADS_STATE_ENDPOINT = "/jobteaser.feedbox.v1alpha1/FeedboxService/GetStateFlag"
export const JOB_ADS_STATE_VALUE = {
  APPLIED: "POST_STATE_APPLIED",
  NONE: "POST_STATE_NONE",
  SAVED: "POST_STATE_SAVED",
} as const

export const UPDATE_USER_SAVED_SEARCH_LAST_SEEN_ENDPOINT =
  "/jobteaser.job_ad.v2alpha2/SavedSearchService/UpdateLastSearchTime"

export const GET_USER_MONO_SAVED_SEARCH_QUERY_KEY = "GET_USER_MONO_SAVED_SEARCH_QUERY_KEY"
export const GET_USER_MONO_SAVED_SEARCH_ENDPOINT = "/v2/jobads/last-saved-search"

export const ADD_USER_MONO_SAVED_SEARCH_ENDPOINT = "/v2/jobads/last-saved-search"

export const DELETE_USER_MONO_SAVED_SEARCH_ENDPOINT = "/v2/jobads/last-saved-search"

export const JOB_ADS_CANDIDACY_TYPES = {
  EMAIL: "EMAIL",
  EXTERNAL: "EXTERNAL",
  INTERNAL: "INTERNAL",
  UNKNOW: "UNKNOWN",
} as const

export const CREATE_RSS_FEED_LINK_ENDPOINT = "/rss/create"

export const JOBADS_ALERTS_ACTIVATE_ENDPOINT = "/api/student_profiles/v1/alerts/activate"
